const ArgumentType = require('../../extension-support/argument-type');
const BlockType = require('../../extension-support/block-type');

const ASCII_FACES = {
    HAPPY: `  .-"""-.
 /        \\
|  o    o  |
|     -     |
|  \\___/  |
 \\_______/`,
    SAD: `  .-"""-.
 /        \\
|  o    o  |
|     -     |
|  /___\\  |
 \\_______/`
};

class Scratch3SeedsFace {
    constructor (runtime) {
        this.runtime = runtime;
    }

    getInfo () {
        return {
            id: 'seedsFace',
            name: 'Faces',
            color1: '#4285F4',
            color2: '#3367D6',
            blocks: [
                // {
                //     opcode: 'printPreset',
                //     blockType: BlockType.COMMAND,
                //     text: 'print [PRESET] face',
                //     arguments: {
                //         PRESET: {
                //             type: ArgumentType.STRING,
                //             menu: 'presetMenu',
                //             defaultValue: 'HAPPY'
                //         }
                //     }
                // },
                {
                    opcode: 'printPresetForSecs',
                    blockType: BlockType.COMMAND,
                    text: 'print [PRESET] face for [SECS] seconds',
                    arguments: {
                        PRESET: {
                            type: ArgumentType.STRING,
                            menu: 'presetMenu',
                            defaultValue: 'HAPPY'
                        },
                        SECS: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 2
                        }
                    }
                }
            ],
            menus: {
                presetMenu: {
                    acceptReporters: false,
                    items: [
                        {text: 'happy', value: 'HAPPY'},
                        {text: 'sad', value: 'SAD'}
                    ]
                }
            }
        };
    }

    // printPreset (args, util) {
    //     const preset = String(args.PRESET);
    //     const text = ASCII_FACES[preset] || ASCII_FACES.HAPPY;
    //     this.runtime.emit('SAY', util.target, 'say', text);
    // }

    printPresetForSecs (args, util) {
        const preset = String(args.PRESET);
        const text = ASCII_FACES[preset] || ASCII_FACES.HAPPY;
        const secs = Math.max(0, Number(args.SECS) || 0);

        this.runtime.emit('SAY', util.target, 'say', text);

        return new Promise(resolve => {
            setTimeout(() => {
                // Clear the bubble after time expires
                this.runtime.emit('SAY', util.target, 'say', '');
                resolve();
            }, secs * 1000);
        });
    }
}

module.exports = Scratch3SeedsFace;
